import * as React from 'react';
import 'dayjs/locale/de';
import SmallConfigTemperatur from '../components/SmallConfigTemperatur'
import SmallConfigAbluft from '../components/SmallConfigAbluft'
import {styled} from '@mui/system';
import axios from "axios";
import {useEffect, useState,useCallback} from "react";
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from "dayjs";
import {ChartContainer, ChartsReferenceLine, ChartsXAxis, ChartsYAxis, ResponsiveChartContainer} from "@mui/x-charts";
import '../styles.css'
import SmallConfigLicht from "./SmallConfigLicht";
import Grid2 from '@mui/material/Grid2';
import styles from '../css/Configuration.module.css'
import { Menu, MenuItem } from '@mui/material';
import Select, {SelectChangeEvent, selectClasses} from '@mui/material/Select';
import { useGrowSetup } from '../GrowSetupContext';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { useDropzone } from 'react-dropzone';
import { Box, Typography, Avatar } from '@mui/material';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import ConstructionRoundedIcon from '@mui/icons-material/ConstructionRounded';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useRef } from 'react';
import { useConfig } from './ConfigContext'
const marks = [
    {
        value: 0,
        label: '0°C',
    },
    {
        value: 20,
        label: '20°C',
    },
    {
        value: 37,
        label: '37°C',
    },
];

function valuetext(value) {
    return `${value}°C`;
}

function valuetextAbweichung(value) {
    return `${value}%`;
}


export default function Configuration(props) {

    const [presets, setPresets] = useState({});
    const [selectedPreset, setSelectedPreset] = useState('');
    const [selectedPresetId, setSelectedPresetId] = useState('');
    const { grow_setup, setGrowSetup } = useGrowSetup();
    const { state, saveConfig} = useConfig()
    const [presetName, setPresetName] = React.useState('');
    const { getRootProps, getInputProps } = useDropzone({
        accept: 'image/*',
        onDrop: (acceptedFiles) => {
            const reader = new FileReader();
            reader.onload = () => {
                var base64String = reader.result;
                var base64String_cut = base64String.split(',')[1];
                setPresets((prev) => ({
                    ...prev,
                    [selectedPreset]: {
                        ...prev[selectedPreset],
                        avatar: base64String,
                    },
                }));
        
                axios.post('/upload_avatar_preset', {
                    base64String_cut,
                    preset_id: presets[selectedPreset].id,
                }).catch(console.error);
            };
            reader.readAsDataURL(acceptedFiles[0]);
        },
      });

    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [presetToDelete, setPresetToDelete] = useState(null);

    const handlePresetChange = (event) => {
        const presetName = event.target.value;
        setSelectedPreset(presetName);

    
        const selectedData = presets[presetName];
        if (!selectedData) return;
    
        // TODO Update des Config Context
        
    };

    function savePreset() {
        const payload = {
            ...state,
            name: presetName,
            user_id: props.user_id,
            user_name: props.user_name,
            is_system_default: false
        };
    
        axios.post('/save_preset', payload, {
            headers: {
                Authorization: 'Bearer ' + props.token,
            },
        }).then(() => {
            fetchData(); // neu laden
        }).catch(error => {
            console.error("Preset speichern fehlgeschlagen:", error);
        });
    }

    const fetchData = async (measure, token) => {
        if (grow_setup > 0) {
            try{
                axios.post('/get_presets', {}, {
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + token,
                        'Method': 'GET',
                    },
                }).then(response => {
                    // Array in Dictionary umwandeln
                    
                    setPresets(response.data);
                });


            } catch (error) {
                console.error(error);


            }
        }
    };

    useEffect(() => {
        fetchData();

    }, []);


    function deletePreset(presetId) {
        axios.delete(`/delete_preset/${presetId}`, {
            headers: {
                Authorization: 'Bearer ' + props.token,
            },
        }).then(() => {
            fetchData(); // Reload Presets
        }).catch(error => {
            console.error("Preset löschen fehlgeschlagen:", error);
        });
    }

    async function savePreset() {
        try {
            await axios.post('/save_preset', {
                name: presetName,
                data: state
            }, {
                headers: {
                    Authorization: 'Bearer ' + props.token
                }
            });
            console.log('Preset gespeichert');
            fetchData();
        } catch (err) {
            console.error('Fehler beim Speichern des Presets:', err);
        }
    }


    return (


        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="de">
            <Select
                value={selectedPreset}
                onChange={(e) => handlePresetChange(e)}
                displayEmpty
                fullWidth
                sx={{ maxHeight: 56, width: 215 }}
            >
                {Object.entries(presets).map(([id, preset]) => (
                    <MenuItem value={id} key={id} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Avatar
                                {...getRootProps()}
                                src={preset.avatar || ''}
                                alt={preset.name}
                                sx={{ width: 36, height: 36, mr: 1 }}
                            >
                                <ConstructionRoundedIcon sx={{ fontSize: '1rem' }} />
                            </Avatar>
                            <input {...getInputProps()} />
                            <ListItemText primary={preset.name} />
                        </Box>

                        {!preset.is_system_default && (
                            <DeleteOutlineIcon
                                color="error"
                                sx={{ ml: 1, cursor: 'pointer' }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setPresetToDelete(preset.id);
                                    setDeleteDialogOpen(true);
                                }}
                            />
                        )}
                    </MenuItem>
                ))}
                <MenuItem value={-1}>
                    <ListItemAvatar>
                        <Avatar sx={{ width: 36, height: 36 }}>
                            <AddRoundedIcon sx={{ fontSize: '1rem' }} />
                        </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary="Preset hinzufügen" />
                </MenuItem>
            </Select>
            <TextField
                label="Preset-Name"
                variant="outlined"
                size="small"
                value={presetName}
                onChange={(e) => setPresetName(e.target.value)}
                sx={{ mt: 2, mb: 1, width: 215 }}
                />
                <Button variant="contained" onClick={savePreset}>
                Preset speichern
                </Button>


            <Grid2 container spacing={3}>
            <Grid2 item size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                    <SmallConfigLicht is_managed={true}></SmallConfigLicht>
            </Grid2>
            <Grid2 item size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                    <SmallConfigTemperatur is_managed={true}  ></SmallConfigTemperatur>
            </Grid2>
            <Grid2 item size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>             
                    <SmallConfigAbluft is_managed={true} ></SmallConfigAbluft>
            </Grid2>
            </Grid2>
            <Box
                sx={{
                position: 'fixed',
                bottom: 16,
                right: 16,
                zIndex: 1000,
                }}
            >
                <Button
                variant="contained"
                color="success"
                sx={{
                    px: 4,
                    py: 1.5,
                    borderRadius: 3,
                    boxShadow: 4,
                    fontWeight: 'bold',
                }}
                onClick={saveConfig}
                >
                Speichern
                </Button>
            </Box>
            <Dialog
                open={deleteDialogOpen}
                onClose={() => setDeleteDialogOpen(false)}
            >
                <DialogTitle>Preset löschen</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Möchtest du das Preset wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDeleteDialogOpen(false)}>Abbrechen</Button>
                    <Button
                        onClick={() => {
                            deletePreset(presetToDelete);
                            setDeleteDialogOpen(false);
                        }}
                        color="error"
                        variant="contained"
                    >
                        Löschen
                    </Button>
                </DialogActions>
            </Dialog>

        </LocalizationProvider>

    );
}


